export enum EventTypes {
  CarrierVisitRefresh = 'CarrierVisitRefresh',
  ReeferTemperatureUpserted = 'ReeferTemperatureUpserted',
  WorkInstructionDeleted = 'WorkInstructionDeleted',
  WorkInstructionFinished = 'WorkInstructionFinished',
  WorkQueueUpserted = 'WorkQueueUpserted',
  JobUpserted = 'JobUpserted',
  WorkInstructionConfirmed = 'WorkInstructionConfirmed',
  EquipmentsJobRefresh = 'EquipmentsJobRefresh',
  WagonWeightUpdated = 'WagonWeightUpdated',
  WorkInstructionJobsUpserted = 'WorkInstructionJobsUpserted',
  CoolingOrderUpserted = 'CoolingOrderUpserted',
  WorkInstructionUpserted = 'WorkInstructionUpserted',
  EquipmentLastPositionOnYard = 'EquipmentLastPositionOnYard',
  CarrierVisitWorkInstructionUpserted = 'CarrierVisitWorkInstructionUpserted',
  EquipmentUpserted = 'EquipmentUpserted',
  EquipmentDeleted = 'EquipmentDeleted',
  TenantUpserted = 'TenantUpserted',
  IssueUpserted = 'IssueUpserted',
  HatchCoverMoveUpserted = 'HatchCoverMoveUpserted',
  HatchCoverMoveDeleted = 'HatchCoverMoveDeleted',
  StoppageReasonUpserted = 'StoppageReasonUpserted',
  StoppageReasonDeleted = 'StoppageReasonDeleted',
  StoppageUpserted = 'StoppageUpserted',
  StoppageDeleted = 'StoppageDeleted',
  EquipmentLastJobUpserted = 'EquipmentLastJobUpserted',
  EquipmentAssignmentUpserted = 'EquipmentAssignmentUpserted',
  ShiftUpserted = 'ShiftUpserted',
  ShiftDeleted = 'ShiftDeleted',
  GangUpserted = 'GangUpserted',
  GangDeleted = 'GangDeleted',
  EquipmentOperatorAssigned = 'EquipmentOperatorAssigned',
  CraneSplitGeneratedForVisit = 'CraneSplitGeneratedForVisit',
}
